import dayjs from "dayjs";

// date and date-time formats in dayjs
export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const DATE_TIMESEC_FORMAT = "YYYY-MM-DD HH:mm";

export function dateFormat(date?: any) {
  return date ? dayjs(date).format(DATE_FORMAT) : "-";
}

export function dateTimeFormat(date?: string) {
  return date ? dayjs(date).format(DATE_TIME_FORMAT) : "-";
}

export function dateTimeSecFormat(date?: any) {
  return date ? dayjs(date).format(DATE_TIMESEC_FORMAT) : "-";
}
